<template>
  <v-container>
    <v-row className="align-center justify-center">
      <v-col cols="12" md="12" align-self="center">
        <div id="chart-percentage-evolution"></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Highcharts from "highcharts"
import Exporting from 'highcharts/modules/exporting'
import Accessibility from "highcharts/modules/accessibility";
Accessibility(Highcharts);
Exporting(Highcharts)
export default {
  props: ['percentageSeries', 'text', 'years','firstYear','lastYear'],
  name: "EvolutionPercentageChart",
  data() {
    return {
      chartRendered: undefined,
    }
  },
  mounted() {
    this.dataSource()
  },
  watch: {
    percentageSeries() {
      if (this.percentageSeries) {
        this.dataSource()
      }
    }
  },
  methods: {
    async dataSource() {
      let chart = document.getElementById('chart-percentage-evolution')
      if (this.percentageSeries && this.years) {
        let range = 'Range: 1985'+' to '+this.years[this.years.length-1]
        this.chartNew(this.percentageSeries,range)
        chart.style.visibility = 'visible'
        chart.style.display = 'block'
      } else {
        chart.style.visibility = 'hidden'
        chart.style.display = 'none'
      }
      this.$emit('chartRenderComplete', this.chartRendered);
    },
    chartNew(series, range) {
      this.chartRendered = Highcharts.chart('chart-percentage-evolution', {
        chart: {
          backgroundColor: this.$vuetify.theme.themes.dark.primary.darken1,
        },
        title: { text: null },
        subtitle: { text: null },
        credits: {
          enabled: false,
          href: 'http://www.simepar.br/',
          text:'by: SIMEPAR',
          style:{ color: '#FFFFFF'}
        },
        exporting: {
          enabled: false,
          filename: this.text,
          chartOptions: {
            title: {
              text: this.text,
              style: {
                color: '#FFFFFF'
              }
            },
          }
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false
            },
            pointStart: 1985
          }
        },
        tooltip: {
          split: true,
          pointFormat: '<span>{series.name}</span>: <b>{point.y:,.2f}%</b><br/>',
          //shared: true, //shared(true) or single(false) ?
          //pointFormat: '<strong style="color:{series.color};font-size: 1.5em;">&#9679 </strong><span>{series.name}</span>: <b>{point.y:,.2f}%</b><br/>',
        },
        yAxis: {
          //min: 0,
          //max: 100,
          //endOnTick: false,
          //startOnTick: false,
          gridLineWidth: 1,
          gridLineColor:'#2D324F',
          labels: {
            format: '{value}',
            style:{ color: '#FFFFFF'}
          },
          title: {
            enabled: true,
            text: 'evolução do uso da terra na bacia (%)',
            style:{ color: '#FFFFFF'}
          },
          accessibility: {
            description: 'evolução do uso da terra na bacia (%)',
          },
        },
        xAxis: {
          gridLineWidth: 1,
          gridLineColor:'#2D324F',
          accessibility: {
            rangeDescription: range
          },
          labels: {
            style:{ color: '#FFFFFF'}
          },
          title: {
            enabled: false,
            style:{ color: '#FFFFFF'}
          }
        },
        legend: {
          enabled: true,
          itemStyle:{ color: '#FFFFFF' },
          itemHoverStyle: { color: '#979797' },
        },
        series: series,
        caption: {
          text: `Gráfico linha baseado nos primeiros dados registrados - Dados históricos da evolução do uso e cobertura da terra em porcentagem (%) de ${this.firstYear} até ${this.lastYear}`,
          style: { color: "#FFFFFF" },
        },
        responsive: {
          rules: [{
            condition: {
              maxWidth: 500
            },
          }]
        }
      });
    },
  },
}
</script>

<style scoped>

</style>
